import { formatDate } from "common/js/date";
import { getHeadImage } from "common/js/getHeadImage";
import { commonParams } from "common/config/config";

let filterDate = (value, formatStr = "yyyy-MM-dd hh:mm") => {
  if (!value) return "";
  // 在ios 上不识别时间- 分开，只认识/ 分开
  if (Object.prototype.toString.call(value) === "[object String]") {
    value = value.replace(/-/g, "/");
  }
  let date = new Date(value);
  return formatDate(date, formatStr);
};

// 字数统计
function wordCount(content) {
  let sLen = 0;
  let str = String(content);
  try {
    str = str.replace(/<[^>]+>/g, "");
    // 先将回车换行符做特殊处理
    str = str.replace(/(\r\n+|\s+)/g, "龘");
    // 处理英文字符数字，连续字母、数字、英文符号视为一个单词
    str = str.replace(/[\x00-\xff]/g, "m");
    // 合并字符m，连续字母、数字、英文符号视为一个单词
    str = str.replace(/m+/g, "*");
    // 去掉回车换行符
    str = str.replace(/龘+/g, "");
    // 返回字数
    sLen = str.length;
  } catch (e) {
    sLen = 0;
  }
  return sLen;
}

function formatPath(path, type) {
  if (path === undefined || path == "") {
    return "";
  }
  var httpReg = /^(http|https)/;
  var fileReg = /^(file)/;
  if (
    path.indexOf("data:image") > -1 ||
    path.indexOf("blob:") > -1 ||
    path.indexOf("file:") > -1
  ) {
    if (path.indexOf("file:///") === 0) {
      path = path.replace("file:///", "cdvfile://umooc_cordova/");
      return path;
    }
    return path;
  } else if (path.indexOf("file:///") === 0) {
    path = path.replace("file:///", "cdvfile://umooc_cordova/");
    return path;
  } else if (!httpReg.test(path) && !fileReg.test(path)) {
    if (path.indexOf("/") === 0) {
      path = path.substring(1, path.length);
    }
    path = commonParams.QINIU_RESOURCE_URL + "/" + path;
    if (type === "image") {
      path =
        path.indexOf("?") === -1
          ? path + "?imageslim|imageView2/0/w/1000/h/1000"
          : path;
    }
    return path;
  } else {
    if (type === "image") {
      path =
        path.indexOf("?") === -1
          ? path + "?imageslim|imageView2/0/w/1000/h/1000"
          : path;
    }
    return path;
  }
}

export { filterDate, getHeadImage, formatPath, wordCount };



// WEBPACK FOOTER //
// ./src/common/filter/filter.js